import React from "react";
import { Moon, Sun, Monitor, Plus, Github } from "lucide-react";
import { useTheme } from "@/lib/theme-context";
import { env } from "@/config/env";

const Header: React.FC = () => {
  const { theme, setTheme } = useTheme();
  const currentPath = window.location.pathname;
  const isOnHomePage = currentPath === "/";
  const isOnSubmitPage = currentPath === "/submit";

  const toggleTheme = () => {
    if (theme === "light") setTheme("dark");
    else if (theme === "dark") setTheme("system");
    else setTheme("light");
  };

  const getThemeIcon = () => {
    switch (theme) {
      case "light":
        return <Sun className="h-5 w-5" />;
      case "dark":
        return <Moon className="h-5 w-5" />;
      default:
        return <Monitor className="h-5 w-5" />;
    }
  };

  return (
    <header
      className={`sticky top-0 z-50 w-full border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 ${
        env.IS_DEVELOPMENT ? "border-t-[3px] border-t-orange-500" : ""
      }`}
    >
      <div className="container mx-auto flex h-16 items-center justify-between px-4">
        <a
          href="/"
          className="flex items-center space-x-2 text-lg sm:text-xl font-bold"
        >
          <span>
            <span className="bg-gradient-to-r from-orange-500 to-red-500 bg-clip-text text-transparent">
              InfrAgents
            </span>
            .com
          </span>
        </a>

        <nav className="hidden md:flex items-center space-x-6">
          <a
            href="/"
            className={`text-sm font-medium transition-colors hover:text-primary pb-1 border-b-2 ${
              isOnHomePage ? "border-orange-500" : "border-transparent"
            }`}
          >
            Discover
          </a>
          <a
            href="/submit"
            className={`text-sm font-medium transition-colors hover:text-primary pb-1 border-b-2 ${
              isOnSubmitPage ? "border-orange-500" : "border-transparent"
            }`}
          >
            Submit Agent
          </a>
        </nav>

        <div className="flex items-center space-x-2">
          <a
            href="/submit"
            className={
              isOnSubmitPage
                ? "inline-flex items-center justify-center rounded-md px-4 py-2 text-sm font-medium transition-colors hover:text-primary md:hidden"
                : "inline-flex items-center justify-center rounded-md bg-orange-500 hover:bg-orange-600 text-white px-4 py-2 text-sm font-medium transition-colors md:hidden"
            }
          >
            <Plus className="h-4 w-4" />
          </a>

          <a
            href="/submit"
            className={
              isOnSubmitPage
                ? "hidden md:inline-flex items-center justify-center rounded-md px-4 py-2 text-sm font-medium transition-colors hover:text-primary"
                : "hidden md:inline-flex items-center justify-center rounded-md bg-orange-500 hover:bg-orange-600 text-white px-4 py-2 text-sm font-medium transition-colors"
            }
          >
            <Plus className="mr-2 h-4 w-4" />
            Submit Agent
          </a>

          <button
            onClick={toggleTheme}
            className="inline-flex items-center justify-center rounded-md w-9 h-9 transition-colors hover:bg-accent hover:text-accent-foreground"
            aria-label="Toggle theme"
          >
            {getThemeIcon()}
          </button>

          <a
            href="https://github.com/chrisurf/infragents"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center rounded-md w-9 h-9 transition-colors hover:bg-accent hover:text-accent-foreground"
            aria-label="GitHub Repository"
          >
            <Github className="h-5 w-5" />
          </a>
        </div>
      </div>
    </header>
  );
};

export default Header;
